require('bijou/base')

$.widget "chopin.direct_debit_form", $.bijou.base,
  _show_form: ->
    applicableFieldsForPersonal =
      @element.find(".js-toggleable-field[data-show='business_type_personal']")
        .closest('.control-block')

    applicableFieldsForCompany =
      @element.find(".js-toggleable-field[data-show='business_type_company']")
        .closest('.control-block')

    accountHolderEl = @element.find('.js-account-holder')
    policyHolderName = accountHolderEl.data('policy-holder')

    businessTypeEl = @element.find('.js-business-type')
    sortCodeEl = @element.find('.sortcode')

    if businessTypeEl.val() != 'Sole trader'
      @._hideFields(applicableFieldsForPersonal)
      @._toggleAccHolderErrorMessage(true)
      @._showFields(applicableFieldsForCompany)
      accountHolderEl.prop('readonly', false).removeClass('readonly')
      accountHolderEl.val('')
    else
      @._hideFields(applicableFieldsForCompany)
      @._toggleAccHolderErrorMessage(false)
      @._showFields(applicableFieldsForPersonal)
      accountHolderEl.prop('readonly', true).addClass('readonly')
      accountHolderEl.val(policyHolderName)

  _create: ->
    businessTypeEl = @element.find('.js-business-type')
    sortCodeEl = @element.find('.sortcode')

    @._show_form()

    businessTypeEl.on 'change', =>
      @._show_form()

    sortCodeEl.on 'keyup', (e) ->
      el = e.target
      if el.value.length == 2 && $.isNumeric(e.key)
        $(el).nextAll('.sortcode').eq(0).focus()

  _hideFields: (fields) ->
    fields
      .addClass('off')
      .find('input')
      .attr('disabled', true)

  _toggleAccHolderErrorMessage: (bool) ->
    @element.find('#direct_debit_form_account_holder_name-error').toggle(bool)

  _showFields: (fields) ->
    fields
      .removeClass('off')
      .find('input')
      .attr('disabled', false)

  _setupSoleTraderForm: (applicableFieldsForCompany,
    applicableFieldsForPersonal,
    policyHolderName,
    accountHolderEl) ->
      @._hideFields(applicableFieldsForCompany)
      @._toggleAccHolderErrorMessage(false)
      @._showFields(applicableFieldsForPersonal)
      accountHolderEl.prop('readonly', true).addClass('readonly')
      accountHolderEl.val(policyHolderName)

$ ->
  $("[data-module=direct_debit_form]").direct_debit_form()
